import React, { useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import i18n from '@/utils/i18n';
import { Direction } from 'reactstrap/types/lib/Dropdown';

type ExportButtonProps = {
  disabled?: boolean;
  isLoading?: boolean;
  direction?: Direction;
  csvCallback?: () => void;
  excelCallback?: () => void;
};

const ExportButton = ({
  disabled = false,
  isLoading = false,
  direction = 'down',
  csvCallback,
  excelCallback,
}: ExportButtonProps) => {
  const [visible, setVisible] = useState(false);

  return (
    <Dropdown
      isOpen={visible}
      toggle={() => {
        setVisible(!visible);
      }}
      direction={direction}
      disabled={disabled || isLoading}
    >
      <DropdownToggle caret color="primary" disabled={disabled || isLoading}>
        {i18n.t('ExportButton:exportAs')}
      </DropdownToggle>

      <DropdownMenu>
        {csvCallback && (
          <DropdownItem
            onClick={() => {
              csvCallback();
            }}
          >
            {i18n.t('ExportButton:exportCSV')}
          </DropdownItem>
        )}

        {excelCallback && (
          <DropdownItem
            onClick={() => {
              excelCallback();
            }}
          >
            {i18n.t('ExportButton:exportExcel')}
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default ExportButton;
